import React from "react";

// import CarListCard from "../CarListCard/CarListCard";

import styles from "./CarList.module.css";
import CarListCard from "../components/CarListCard/CarListCard";

const CarList = ({ cars = [] }) => {
    if (!cars.length) {
        return (
            <div
                className={styles.empty}
                dir="rtl"
            >
                <div className={styles.emptyIcon}>
                    🚗
                </div>

                <div className={styles.emptyTitle}>
                    خودرویی پیدا نشد
                </div>

                <div className={styles.emptyText}>
                    خودرویی مطابق فیلترهای انتخاب‌شده وجود ندارد.
                </div>
            </div>
        );
    }

    return (
        <div
            className={styles.list}
            dir="rtl"
        >
            {cars.map((car) => (
                <CarListCard
                    key={car.id}
                    car={car}
                />
            ))}
        </div>
    );
};

export default CarList;